export function IconHandshake({ size = 24, className }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      focusable="false"
      aria-hidden="true"
    >
      {/* Linker Arm/Unterarm */}
      <path d="M2 14 H7" />
      {/* Rechter Arm/Unterarm */}
      <path d="M22 14 H17" />
      {/* Linke Hand/Faust (kommt von links, Daumen oben) */}
      <path d="M7 11 C7 10 8 9.5 9 10 L13 12 C14 12.5 14 14 13 14.5 L11 15.5 C10 16 8 16 7 15 Z" />
      {/* Rechte Hand/Faust (kommt von rechts, greift in linke) */}
      <path d="M17 12.5 C17 11.5 16 11 15 11.5 L11 13.5 C10 14 10 15.5 11 16 L13 17 C14 17.5 16 17.5 17 16.5 Z" />
      {/* Daumen-Andeutung links oben */}
      <path d="M9 10 L10.5 8.5" />
      {/* Daumen-Andeutung rechts oben */}
      <path d="M15 11.5 L13.5 10" />
    </svg>
  );
}
